import { z } from 'zod';

export const prosjektpratSchema = z.object({
  email: z.email('E-posten er ugyldig.'),
  phone: z
    .string()
    .regex(/^(\+?47)?[2-9]\d{7}$/, 'Telefonnummeret er ugyldig.'),
  projectDetails: z
    .string()
    .min(1, 'Her må du nesten skrive noe før du sender inn!'),
});
